import cookie from 'cookie';
import {gladiatorService} from '@jobseeker/common-core/services';
import {COOKIE_LOGIN_AUTH} from '@jobseeker/common-core/constants';
import type {GetServerSidePropsContext} from 'next/types';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export async function getMultiApplyVariant(
  context: GetServerSidePropsContext
): Promise<boolean> {
  if (isAppIimjobs || !context.req?.headers?.cookie) return true;

  try {
    const abCookies = cookie.parse(context.req.headers.cookie);
    if (!abCookies?.[COOKIE_LOGIN_AUTH]) return true;

    const validateInfo = await gladiatorService.validate('validate', {
      headers: {cookie: context.req?.headers?.cookie},
    });
    const sessionToken = validateInfo?.token;
    if (!sessionToken) return true;

    const abResponse = await fetch(
      `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_AB_TEST}/get-variant?experimentId=2`,
      {
        method: 'GET',
        headers: {
          referer: `https://www.${process.env.NEXT_PUBLIC_APP_DOMAIN}/`,
          Authorization: `Bearer ${sessionToken}`,
          cookie: abCookies?.['_t_ds'] ? `_t_ds=${abCookies['_t_ds']}` : '',
          _t_ds: abCookies?.['_t_ds'] ? abCookies['_t_ds'] : '',
        },
      }
    );
    const abData = await abResponse.json();
    const variantName = abData?.data?.variant?.name;
    return !!variantName && variantName === 'control';
  } catch (_) {
    return true;
  }
}
